import { render, staticRenderFns } from "./MaterialPicker.vue?vue&type=template&id=e3da1d20&scoped=true"
import script from "./MaterialPicker.vue?vue&type=script&lang=js"
export * from "./MaterialPicker.vue?vue&type=script&lang=js"
import style0 from "./MaterialPicker.vue?vue&type=style&index=0&id=e3da1d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_574b8669d18f67ce8fdb77c3b9cb8ea1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3da1d20",
  null
  
)

export default component.exports